/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MainInputs */

const en_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const ar_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القائمة الرئيسية`)
};

const bn_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রধান নেভিগেশন`)
};

const de_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptnavigation`)
};

const es_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación principal`)
};

const fr_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation principale`)
};

const pt_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação principal`)
};

const zh_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主导航`)
};

const tr_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana gezinme`)
};

const ru_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основная навигация`)
};

const pl_nav_main = /** @type {(inputs: Nav_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nawigacja główna`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Nav_MainInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_main = /** @type {((inputs?: Nav_MainInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MainInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_main(inputs)
	if (locale === "bn") return bn_nav_main(inputs)
	if (locale === "de") return de_nav_main(inputs)
	if (locale === "es") return es_nav_main(inputs)
	if (locale === "fr") return fr_nav_main(inputs)
	if (locale === "pt") return pt_nav_main(inputs)
	if (locale === "zh") return zh_nav_main(inputs)
	if (locale === "tr") return tr_nav_main(inputs)
	if (locale === "ru") return ru_nav_main(inputs)
	if (locale === "pl") return pl_nav_main(inputs)
	return en_nav_main(inputs)
});